import makeStyles from "@material-ui/core/styles/makeStyles";

export default makeStyles((theme) => ({
  card: {
    width: "100%",
    height: "100%",
    display: "flex",
  },
  unitContainer: {
    backgroundColor:  theme.palette.type === "light"
    ? [theme.palette.secondary.tint15, "!important"]
    : [theme.palette.secondary.tint60, "!important"],
    display: "flex",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
    minWidth: theme.spacing(15),
  },
  priceContainer: {
    flexWrap: "noWrap",
  },
  priceItemsContainer: {
    height: "100%",
  },
  priceItemText: {
    color: theme.palette.secondary.tint60,
  },
  unitText: {
    transform: "rotate(90deg)",
  },
}));
